import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section<{
  backgroundColor: Queries.kontent_item_announcement_button_elements_background_color_enum;
}>`
  ${({ backgroundColor }) =>
    backgroundColor !== 'white' ? tw`bg-ui-colours-ui1` : tw`bg-neutrals-n1`}
`;

export const Container = styled.div`
  ${tw`container container-stack-context`}
  ${tw`flex justify-center`}
  ${tw`px-2 lg:px-0`}
  container-type: inline-size;
  container-name: pricing-container;
`;

export const Buttons = styled.div`
  ${tw`flex flex-col lg:flex-row gap-2 lg:gap-3`}
`;

export const InfoTagWrapper = styled.span`
  @container pricing-container (width > 400px) {
    ${tw`mr-[4px]`}
  }
`;

export const StyledLink = styled.a``;

export const ButtonWrapper = styled.div<{ hasInfoTag?: boolean }>`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-s text-center text-primary-p1`}
  ${tw`flex items-center`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`border-2 border-secondary-s1 hover:border-primary-p1`}
  ${tw`min-h-[40px]`}

  @container pricing-container (width <= 400px) {
    ${tw`flex-col`}
    ${tw`gap-1`}
    ${tw`p-2`}
    ${tw`rounded-lg`}
  }
  @container pricing-container (width > 400px) {
    ${tw`flex-row`}
    ${tw`gap-[4px]`}
    ${tw`pr-[22px]`}
    ${tw`rounded-[40px]`}
    ${({ hasInfoTag }) => (hasInfoTag ? tw`pl-[4px]` : tw`pl-[22px]`)}
  }
`;
